import { useState } from 'react';
import { isEmpty, get, difference } from 'lodash';
import { Button, Modal, Typography } from '@ts/storybook';
import IconRules from './IconRules';
import IconRuleForm from './IconRuleForm';
import { useTranslation } from 'react-i18next';
import { IForm } from '@ts/ui-models';

interface IconRulesCrudProps extends IForm {}

const IconRulesCrud = (props: IconRulesCrudProps) => {
  const [showModal, setShowModal] = useState(false);
  const [newIconRule, setNewIconRule] = useState<any>(null);

  const { values, mode, onChange } = props;

  const isViewMode = mode === 'view';

  const shouldRenderDefineRuleButton = () => {
    if (values.type == 'list' && isEmpty(values.possibleValues)) return false;
    return !(values.type === 'date' || values.type === 'time');
  };

  const shouldDisableAddRule = !(
    newIconRule?.icon?.name &&
    newIconRule?.icon?.name !== '' &&
    !newIconRule?.icon?.name.includes('undefined') &&
    newIconRule?.rule &&
    newIconRule?.rule.operation &&
    newIconRule?.rule.operand !== undefined &&
    newIconRule?.rule.operand !== null
  );

  const getClonedArray = path => {
    const value = get(props, `values.${path}`, []);
    return [...value];
  };

  const handleAddIconRule = () => {
    if (newIconRule?.rule && newIconRule?.icon) {
      const toAdd = getClonedArray('iconRulesToAdd');
      toAdd.push(newIconRule);
      onChange('iconRulesToAdd', toAdd);
    }
    setShowModal(false);
    setNewIconRule(null);
  };

  const handleRemoveIconRuleToAdd = idx => {
    const toAdd = getClonedArray('iconRulesToAdd');
    toAdd.splice(idx, 1);
    onChange('iconRulesToAdd', toAdd);
  };

  const handleRemoveIconRule = idx => {
    const toRemove = getClonedArray('iconRulesToRemove');
    toRemove.push(values.iconRules[idx].logicalId);
    const iconRules = getClonedArray('iconRules');
    iconRules.splice(idx, 1);
    onChange('iconRulesToRemove', toRemove);
    onChange('iconRules', iconRules);
  };

  const extractOperands = array => {
    if (!array) return [];
    return array.map(iconRule => get(iconRule, 'rule.operand', '???'));
  };

  const getAlreadyInUseOperands = () => {
    // operands in (iconRules - iconRulesToRemove) + iconRulesToAdd
    const { iconRules, iconRulesToAdd, iconRulesToRemove } = values;
    let inUse = extractOperands(iconRules);
    if (!isEmpty(iconRulesToRemove)) {
      let toRemove = iconRules.filter(iconRule => {
        return iconRulesToRemove.find(id => iconRule.logicalId == id);
      });
      inUse = difference(inUse, extractOperands(toRemove));
    }
    return inUse.concat(extractOperands(iconRulesToAdd));
  };

  const typeProps = {
    type: values.type,
    possibleValues: values.possibleValues,
    // add other indicators typeProps in a future ??
  };
  return (
    <>
      <div className="my-4">
        <Typography variant="h6" gutterBottom text={['Icon rules', ' ']} />
        <IconRules rows={values.iconRules} disabled={mode == 'view'} onDelete={handleRemoveIconRule} />
      </div>
      {mode !== 'view' && (
        <div className="my-4">
          <Typography variant="h6" gutterBottom text="Icon rules to add upon saving" />
          <IconRules rows={values.iconRulesToAdd} onDelete={handleRemoveIconRuleToAdd} />
          {shouldRenderDefineRuleButton() && (
            <Button
              className="mt-4"
              variant="outlined"
              onClick={() => setShowModal(true)}
              disabled={isViewMode}
              label="Define new icon rule"
            />
          )}
        </div>
      )}
      <Modal
        withHeader
        open={showModal}
        title="Add icon rule"
        labelOk="Confirm"
        labelCancel="Cancel"
        onSubmit={handleAddIconRule}
        disabled={shouldDisableAddRule}
        onClose={() => {
          setNewIconRule(null);
          setShowModal(false);
        }}
        fullWidth
        maxWidth="lg"
      >
        <IconRuleForm
          values={newIconRule}
          alreadyInUseOperands={getAlreadyInUseOperands()}
          onChange={setNewIconRule}
          {...typeProps}
        />
      </Modal>
    </>
  );
};

export default IconRulesCrud;
